<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('quotation.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('quotation.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="d-flex">
            <ts-button
              outline
              color="info"
              @click="$router.push({ name: 'quotation-create' })"
              >{{ $t('add_new') }}</ts-button
            >
          </div>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('quotation.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.quot_date }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.quot_number }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.inquiry.full_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.grade.grade_name_foreign }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.study_time }}
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ record.fee_amount }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a
                href="#"
                v-tooltip="$t('tooltip.show')"
                class="mr-2 text-primary"
                @click.prevent="show(record)"
              >
                <i class="fas fa-eye"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('pdf')"
                class="text-danger"
                @click.prevent="pdfView(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
              <a
                href="#"
                @click.prevent="deleteRecord(record)"
                :disabled="record._deleting"
              >
                <i
                  class="fas fa-circle-notch spin ml-2"
                  v-if="record._deleting"
                ></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-drawer
        :title="$t('quotation.filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        width="300px"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{ $t('quotation.branch') }}</label>
              <a-select
                style="width: 257px"
                v-model="branch_id"
                :options="branchs"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('quotation.quotationDate') }}</label>
                <a-range-picker
                  format="DD-MM-YYYY"
                  :defaultValue="rangeDate"
                  :defaultPickerValue="rangeDate"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
        </div>
      </a-drawer>
    </ts-card>
  </div>
</template>
  
<script>

import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import PreviewPDF from './component/preview-pdf'

export default {
    name: 'quotation',
    data () {
      return {
        branchs: [],
        visible: false,
        loading: false,
        rangeDate: [moment().add(-1, 'Month'), moment()]
      }
    },
    computed: {
      ...mapState('quotation', ['resources', 'pagination']),
      search: {
        get () {
          return this.$store.state.quotation.search
        },
        set (newValue) {
          this.$store.commit('quotation/SET_SEARCH', newValue)
          this.$store.commit('quotation/RESET_CURRENT_PAGE')
        }
      },
      branch_id: {
        get () {
          return this.$store.state.quotation.branch_id
        },
        set (newValue) {
          this.$store.commit('quotation/SET_BRANCH_ID', newValue)
        }
      },
      columns () {
        return [
          { name: this.$t('quotation.branch') },
          { name: this.$t('quotation.quotationDate')},
          { name: this.$t('quotation.quotationNumber') },
          { name: this.$t('quotation.studentName') },
          { name: this.$t('quotation.grade') },
          { name: this.$t('quotation.studyTime') },
          { name: this.$t('quotation.totalAmount'), style: 'text-align:center' },
          { name: this.$t('actions'), style: 'text-align:center; width:7%' }
        ]
      }
    },
    created () {
      this.branch_id = [this.$store.state.authUser.default_branch_id]
      this.fetchData();
      this.getBranch();
    },
    methods: {
      getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
      },
      fetchData (attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'quotation/fetch',
          Object.assign({}, { branch_id: this.branch_id },attributes)
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
      },
      dateRangeChange(dateRange) {
        this.$store.commit(
          'quotation/SET_DATE_FROM',
          dateRange[0].format('DD-MM-YYYY')
        )
        this.$store.commit(
          'quotation/SET_DATE_TO',
          dateRange[1].format('DD-MM-YYYY')
        )
        this.fetchData()
      },
      pdfView (record) {
        this.$modal.show(
          PreviewPDF,
          {
            url: null,
            quot_id: record.quot_id
          },
          {
            height: 'auto',
            width: '60%',
            scrollable: true,
            draggable: '.form-header',
            clickToClose: false
          }
        )
      },
      show (record) {
        this.$store.commit('quotation/SET_SHOW_DATA', record)
        this.$router.push({
          name: 'quotation-show',
          params: { id: record.quot_id }
        })
      },
      async deleteRecord(record) {
        if (await this.$confirmModal.danger('Are you sure to delete ?')) {
          record._deleting = true
          this.$store
            .dispatch('quotation/destroy', record.quot_id)
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              record._deleting = false
            })
            .catch(error => {
              this.$toasted.error(error.message)
              record._deleting = false
            })
        }
      }
    },
    watch: {
      search: debounce(function (search) {
        this.fetchData({ search, branch_id: this.branch_id })
      }, 500),
      branch_id: debounce(function (value) {
        this.fetchData({ branch_id: value })
      }, 500),
    }
  }
</script>
  